import styles from "./ShowroomSelect.module.css";

interface Props {
  buyers: Array<{ email: string; id: string }>;
  value?: number | null;
  onBuyerChange: (value: number) => void;
}

export const ShowroomBuyerSelect = ({
  buyers,
  value,
  onBuyerChange
}: Props) => {
  const handleBuyerChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onBuyerChange(Number(e.target.value));
  };

  return (
    <select
      className={styles.select}
      value={value ?? ""}
      onChange={handleBuyerChange}
    >
      <option value="" disabled>
        Velg kjøper
      </option>
      {buyers?.map((buyer) => (
        <option key={buyer.id} value={buyer.id}>
          {buyer.email}
        </option>
      ))}
    </select>
  );
};
